import { createContext } from 'react';

export interface GroupContextValue {
  className?: string;
}

export const GroupContext = createContext<GroupContextValue>({});
